import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

export interface UserData {
  name: string;
  email: string;
  roles: string[];
}
export interface CreateUserMutationArguments {
  axios: AxiosInstance;
  userData: UserData;
}

async function createUser(axios: AxiosInstance, userData: UserData): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/users`, {
    ...userData,
  });
  return data;
}

export default function useCreateUserMutation() {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userData: UserData) => createUser(axios, userData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['OPUsers'],
      });
    },
  });
}
